import { Environment } from "../app/shared/data/models/environment.model";

export const environment: Environment = {
  production: false,
  apiUrl: 'https://localhost:53694/api',
  s3BaseUrl: 'https://howdy-web-app.s3.eu-west-1.amazonaws.com/',
  host: 'localhost',
  ssoUrl: 'https://wlb-uat-g-sso.azurewebsites.net',
  raygunApiKey: '__RAYGUN_API_KEY__'
};
